module.exports = "data:application/vnd.ms-fontobject;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIzMDc5OWVmYTViZjc0MTI5NDY4YWQ0ZTI1NzU1MWRjMy5lb3QiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Regular.eot
// module id = 100
// module chunks = 0